document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('.hero-slide')];
    const dots = [...hero.querySelectorAll('.hero-dot')];
    let current = 0;

    function show(index) {
      slides.forEach((slide, slideIndex) => slide.classList.toggle('active', slideIndex === index));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === index));
      current = index;
    }

    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    if (slides.length > 1) {
      setInterval(() => show((current + 1) % slides.length), 6000);
    }
  });

  const imageModal = document.querySelector('[data-product-image-modal]');
  const imageOpen = document.querySelector('[data-product-image-open]');
  const imageModalImg = document.querySelector('[data-product-image-modal-img]');
  const imageZoomIn = document.querySelector('[data-product-image-zoom-in]');
  const imageZoomOut = document.querySelector('[data-product-image-zoom-out]');
  const imageReset = document.querySelector('[data-product-image-reset]');
  const imageDisplay = imageOpen?.querySelector('img');
  const imageThumbnails = [...document.querySelectorAll('[data-product-thumbnail]')];
  const variantSelect = document.querySelector('#variant-select');
  let imageZoom = 1;

  function setImageZoom(zoom) {
    imageZoom = Math.min(Math.max(zoom, 1), 3);
    if (imageModalImg) {
      imageModalImg.style.width = `${Math.round(92 * imageZoom)}%`;
      imageModalImg.style.maxWidth = imageZoom === 1 ? '92%' : 'none';
      imageModalImg.style.maxHeight = imageZoom === 1 ? '92%' : 'none';
    }
  }

  function openImageModal() {
    if (!imageModal || !imageModalImg || !imageOpen) return;
    imageModalImg.src = imageOpen.dataset.imageSrc;
    imageModalImg.alt = imageOpen.dataset.imageAlt || '';
    setImageZoom(1);
    imageModal.classList.add('active');
    imageModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-image-modal-open');
  }

  function closeImageModal() {
    if (!imageModal) return;
    imageModal.classList.remove('active');
    imageModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-image-modal-open');
  }

  function selectProductImage({ imageSrc, imageZoomSrc, imageAlt = '', imageId = '' }) {
    if (!imageOpen || !imageDisplay || !imageSrc) return;

    imageDisplay.src = imageSrc;
    imageDisplay.alt = imageAlt;
    imageOpen.dataset.imageSrc = imageZoomSrc || imageSrc;
    imageOpen.dataset.imageAlt = imageAlt;

    imageThumbnails.forEach((thumbnail) => {
      const isSelected = String(thumbnail.dataset.imageId) === String(imageId);
      thumbnail.classList.toggle('active', isSelected);
      thumbnail.setAttribute('aria-pressed', String(isSelected));
    });
  }

  imageThumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      selectProductImage({
        imageSrc: thumbnail.dataset.imageSrc,
        imageZoomSrc: thumbnail.dataset.imageZoomSrc,
        imageAlt: thumbnail.dataset.imageAlt,
        imageId: thumbnail.dataset.imageId,
      });
    });
  });

  variantSelect?.addEventListener('change', () => {
    const selectedVariant = variantSelect.selectedOptions[0];
    if (!selectedVariant?.dataset.imageSrc) return;

    selectProductImage({
      imageSrc: selectedVariant.dataset.imageSrc,
      imageZoomSrc: selectedVariant.dataset.imageZoomSrc,
      imageAlt: selectedVariant.dataset.imageAlt,
      imageId: selectedVariant.dataset.imageId,
    });
  });

  imageOpen?.addEventListener('click', openImageModal);
  imageZoomIn?.addEventListener('click', () => setImageZoom(imageZoom + 0.25));
  imageZoomOut?.addEventListener('click', () => setImageZoom(imageZoom - 0.25));
  imageReset?.addEventListener('click', () => setImageZoom(1));

  document.querySelectorAll('[data-product-image-close]').forEach((trigger) => {
    trigger.addEventListener('click', closeImageModal);
  });

  imageModal?.addEventListener('wheel', (event) => {
    event.preventDefault();
    setImageZoom(imageZoom + (event.deltaY < 0 ? 0.15 : -0.15));
  }, { passive: false });

  document.querySelectorAll('[data-collection-filter]').forEach((filter) => {
    const toggle = filter.querySelector('[data-collection-filter-toggle]');
    const menu = filter.querySelector('[data-collection-filter-menu]');
    if (!toggle || !menu) return;

    function closeFilter() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = !menu.hidden;
      menu.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    document.addEventListener('click', (event) => {
      if (!filter.contains(event.target)) closeFilter();
    });
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerOverlay = document.querySelector('.cart-drawer-overlay');
  const drawerItems = document.querySelector('[data-cart-drawer-items]');
  const drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  const cartCount = document.querySelector('[data-cart-count]');

  if (!drawer || !drawerOverlay || !drawerItems || !drawerSubtotal) return;

  const activeCurrency = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';
  const moneyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: activeCurrency,
  });

  function formatMoney(cents) {
    return moneyFormat.format(cents / 100);
  }

  function openCartDrawer() {
    drawer.classList.add('active');
    drawerOverlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeCartDrawer() {
    drawer.classList.remove('active');
    drawerOverlay.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function renderCart(cart) {
    drawerSubtotal.textContent = formatMoney(cart.total_price);
    if (cartCount) cartCount.textContent = cart.item_count;

    if (!cart.items.length) {
      drawerItems.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
      return;
    }

    drawerItems.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" loading="lazy">`
        : '<span>No image</span>';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<small>${item.variant_title}</small>`
        : '';

      return `
        <div class="cart-drawer-item">
          <a class="cart-drawer-image" href="${item.url}">${image}</a>
          <div class="cart-drawer-details">
            <a class="cart-drawer-title" href="${item.url}">${item.product_title}</a>
            ${variant}
            <p>${item.quantity} x ${formatMoney(item.final_price)}</p>
          </div>
        </div>
      `;
    }).join('');
  }

  async function refreshCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', async (event) => {
      event.preventDefault();
      openCartDrawer();
      try {
        await refreshCart();
      } catch (error) {
        window.location.href = trigger.href;
      }
    });
  });

  document.querySelectorAll('[data-cart-drawer-close]').forEach((trigger) => {
    trigger.addEventListener('click', closeCartDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeImageModal();
    if (event.key === 'Escape') closeCartDrawer();
  });

  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const requiredOption = form.querySelector('[data-required-option]');
      const optionError = form.querySelector('[data-option-error]');

      if (requiredOption && !requiredOption.value) {
        optionError.hidden = false;
        requiredOption.classList.add('field-error');
        requiredOption.focus();
        return;
      }

      if (optionError) optionError.hidden = true;
      requiredOption?.classList.remove('field-error');

      const submitButton = form.querySelector('[type="submit"]');
      submitButton?.setAttribute('disabled', 'disabled');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!response.ok) throw new Error('Unable to add item');

        await refreshCart();
        openCartDrawer();
      } catch (error) {
        form.submit();
      } finally {
        submitButton?.removeAttribute('disabled');
      }
    });

    form.querySelectorAll('[data-required-option]').forEach((select) => {
      select.addEventListener('change', () => {
        const optionError = form.querySelector('[data-option-error]');
        if (select.value) {
          select.classList.remove('field-error');
          if (optionError) optionError.hidden = true;
        }
      });
    });
  });
});
